












import { Vue, Component, Prop } from 'vue-property-decorator';
import LoaderCircular from '@/components/LoaderCircular.vue';
import Button from '@/components/Button.vue';
import VideoPlayer from '@/video/player/components/VideoPlayer.vue';

@Component({
  components: {
    LoaderCircular,
    Button,
    VideoPlayer,
  },
})
export default class VideoLoaderPage extends Vue {
  @Prop() video: File;

  videoPlayer: HTMLVideoElement;

  get videoStream(): string {
    const videoBlob: Blob = this.video as Blob;
    return window.URL.createObjectURL(videoBlob);
  }
}
